import { axiosClient } from '@src/api/apiClient/axiosClient';

export const tenantUserResendInvitationApiClient = {
  resendInvitation: async (id: number, params: unknown) => {
    return await axiosClient.put(`/tenant/tenant-users/resend-invitation/${id}`, params);
  },
};
